// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { harvestSessionId } from './HarvestSession';
import { z } from 'zod';
export const harvestProtocolId = (z.number());
export const harvestProtocol = z.object({
    id: harvestProtocolId,
    name: z.string().nullable(),
    description: z.string().nullable(),
    parent_protocol_id: harvestProtocolId.nullable(),
    version: z.string().nullable(),
    changelog: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    harvest_session_id: harvestSessionId.nullable(),
    sort_order: z.number(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const harvestProtocolInitializer = z.object({
    id: harvestProtocolId.optional(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    parent_protocol_id: harvestProtocolId.optional().nullable(),
    version: z.string().optional().nullable(),
    changelog: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    harvest_session_id: harvestSessionId.optional().nullable(),
    sort_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const harvestProtocolMutator = z.object({
    id: harvestProtocolId.optional(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    parent_protocol_id: harvestProtocolId.optional().nullable(),
    version: z.string().optional().nullable(),
    changelog: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    harvest_session_id: harvestSessionId.optional().nullable(),
    sort_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestProtocol.js.map